export async function getArrayBuffer(
  blob?: Blob | Buffer | null,
): Promise<ArrayBuffer | undefined> {
  if (blob == null) {
    return undefined;
  }
  if (blob instanceof Blob) {
    return await blob.arrayBuffer();
  }
  if (Buffer.isBuffer(blob)) {
    return new Uint8Array(blob).buffer;
  }
  return undefined;
}
